import Image from 'next/image';
import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import avatar1 from './images/avatar-1.avif';
import avatar2 from './images/avatar-2.avif';
import avatar3 from './images/avatar-3.avif';
import styles from './SocialProof.module.scss';

export default function SocialProof() {
  return (
    <div className={styles.container}>
      <div aria-hidden className={styles.avatars}>
        <Image src={avatar1} alt="" className={styles.avatar} />
        <Image src={avatar2} alt="" className={styles.avatar} />
        <Image src={avatar3} alt="" className={styles.avatar} />
      </div>
      <Typography variant="text200bold">
        <FormattedMessage defaultMessage="Trusted by millions of trailgoers" />
      </Typography>
    </div>
  );
}
